import cn from 'classnames';

import BlockLink from '@/components/BlockLink';
import { type TwoColumnTextProps } from './TwoColumnText.types';

const TwoColumnText: React.FC<TwoColumnTextProps> = ({
  showTitle = true,
  title,
  smallTitle,
  hasContent,
  content,
  linkInternal,
  linkExternal,
  linkText,
}) => (
  <div className="two-col-text-block">
    <h2 className={cn('two-col-text-block__heading', { h4: smallTitle })}>
      {showTitle && title && title}
    </h2>
    {hasContent && (
      <div className="two-col-text-block__main">
        <div
          className="two-col-text-block__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        {linkText && (
          <BlockLink
            linkText={linkText}
            linkExternal={linkExternal}
            linkInternal={linkInternal}
            buttonStyle={linkInternal && 'secondary'}
            arrowFill={linkInternal && 'var(--color-white)'}
          />
        )}
      </div>
    )}
  </div>
);

export default TwoColumnText;
